import { createContext, useContext } from 'react'

export const UI_KIT_OFF = Object.freeze({ button: false, confirm: false })

export const UiKitContext = createContext(UI_KIT_OFF)

export const useUiKit = () => useContext(UiKitContext)
